export function initCustomSelect(targetSelect) {
    var defaulttext = targetSelect.value;

    targetSelect.previousSibling.innerHTML = defaulttext;

    targetSelect.addEventListener('change',function(e){
    var defaulttext2 = e.target.value; 
        e.target.previousSibling.innerHTML = defaulttext2;
    });
}